// import React, { useState } from "react";
// import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
// import PlacesAutocomplete, {
//   geocodeByAddress,
//   getLatLng,
// } from "react-places-autocomplete";

// const containerStyle = {
//   width: "100%",
//   height: "500px",
// };

// const initialCenter = {
//   lat: -34.397,
//   lng: 150.644,
// };

// const MapComponent = () => {
//   const [selectedPosition, setSelectedPosition] = useState(initialCenter);
//   const [address, setAddress] = useState("");
//   const [mapVisible, setMapVisible] = useState(false);
//   const apiKey = "AIzaSyC-94El9frgOdBJdF8UnvFYWkBfTqTyp5Y";

//   const handleSelect = async (value) => {
//     try {
//       const results = await geocodeByAddress(value);
//       const latLng = await getLatLng(results[0]);
//       setSelectedPosition(latLng);
//       setAddress(value);
//       setMapVisible(true);
//     } catch (error) {
//       console.error("Error:", error);
//     }
//   };

//   const handleMarkerDragEnd = async (event) => {
//     const { latLng } = event;
//     const lat = latLng.lat();
//     const lng = latLng.lng();
//     setSelectedPosition({ lat, lng });

//     // Perform reverse geocoding using Google Maps Geocoding API
//     const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

//     try {
//       const response = await fetch(geocodeUrl);
//       const data = await response.json();
//       if (data.results && data.results.length > 0) {
//         const newAddress = data.results[0].formatted_address;
//         setAddress(newAddress);
//       } else {
//         console.error("No results found");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     }

//     console.log("Marker position:", { lat, lng });
//   };

//   return (
//     <>
//       <PlacesAutocomplete
//         value={address}
//         onChange={setAddress}
//         onSelect={handleSelect}
//       >
//         {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
//           <div>
//             <input
//               {...getInputProps({
//                 placeholder: "Search for a location...",
//                 className: "location-search-input",
//               })}
//             />
//             <div className="autocomplete-dropdown-container">
//               {loading && <div>Loading...</div>}
//               {suggestions.map((suggestion) => {
//                 const className = suggestion.active
//                   ? "suggestion-item--active"
//                   : "suggestion-item";
//                 return (
//                   <div
//                     {...getSuggestionItemProps(suggestion, {
//                       className,
//                     })}
//                     key={suggestion.placeId}
//                   >
//                     <span>{suggestion.description}</span>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}
//       </PlacesAutocomplete>

//       {mapVisible && (
//         <GoogleMap
//           mapContainerStyle={containerStyle}
//           center={selectedPosition}
//           zoom={15}
//         >
//           <Marker
//             position={selectedPosition}
//             draggable={true}
//             onDragEnd={handleMarkerDragEnd}
//           />
//         </GoogleMap>
//       )}
//     </>
//   );
// };

// export default MapComponent;
import React, { useState } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const initialCenter = {
  lat: -34.397,
  lng: 150.644,
};

const MapComponent = () => {
  const [selectedPosition, setSelectedPosition] = useState(initialCenter);
  const [address, setAddress] = useState("");
  const [mapVisible, setMapVisible] = useState(false);
  const apiKey = "AIzaSyC-94El9frgOdBJdF8UnvFYWkBfTqTyp5Y";

  const handleSelect = async (value) => {
    try {
      const results = await geocodeByAddress(value);
      const latLng = await getLatLng(results[0]);
      setSelectedPosition(latLng);
      setAddress(value);
      setMapVisible(true);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleMarkerDragEnd = async (event) => {
    const { latLng } = event;
    const lat = latLng.lat();
    const lng = latLng.lng();
    setSelectedPosition({ lat, lng });

    // Perform reverse geocoding using Google Maps Geocoding API
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

    try {
      const response = await fetch(geocodeUrl);
      const data = await response.json();
      if (data.results && data.results.length > 0) {
        const newAddress = data.results[0].formatted_address;
        setAddress(newAddress);
      } else {
        console.error("No results found");
      }
    } catch (error) {
      console.error("Error:", error);
    }

  };

  const handleClose = () => {
    setMapVisible(false);
  };

  return (
    <>
      <PlacesAutocomplete
        value={address}
        onChange={setAddress}
        onSelect={handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <input
              {...getInputProps({
                placeholder: "Search for a location...",
                className: "location-search-input",
              })}
            />
            <div className="autocomplete-dropdown-container">
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion) => {
                const className = suggestion.active
                  ? "suggestion-item--active"
                  : "suggestion-item";
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                    })}
                    key={suggestion.placeId}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>

      <Modal open={mapVisible} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={selectedPosition}
            zoom={15}
          >
            <Marker
              position={selectedPosition}
              draggable={true}
              onDragEnd={handleMarkerDragEnd}
            />
          </GoogleMap>
        </Box>
      </Modal>
    </>
  );
};

export default MapComponent;
